import * as _ from "lodash";
import * as React from "react";

import { changeRequestsToAttributeGroup } from "../../../Helpers/changeRequests";
// import { selectLink } from '../../../Helpers/links';
import * as Models from "../../../Models";
import Card from "../../General/Card";
import ItemGroup from "../../General/ItemGroup";
import Loader from "../../General/loader";
import PlainHeader from "../Details/PlainHeader";
import { useChangeRequests } from "../../../Api/azure";

export default function ChangeRequestList() {
    const { data: changeRequests, isFetching, refetch } = useChangeRequests();
    const isPending = (input: Models.ChangeRequest): boolean =>
        ["created", "pending"].includes(input.status);
    const changeRequestsList = _.orderBy(changeRequests, "createdDate", "desc");

    const pendingAttributeGroup: Models.AttributeGroup =
        changeRequestsToAttributeGroup(
            changeRequestsList.filter(isPending) ?? [],
            "Pending"
        );
    const completedAttributeGroup: Models.AttributeGroup =
        changeRequestsToAttributeGroup(
            changeRequestsList.filter((cr) => !isPending(cr)) ?? [],
            "Completed"
        );

    const content: JSX.Element = (
        <div>
            {isFetching && <Loader />}
            {!isFetching && (
                <div>
                    <button
                        className="btn btn-primary mb-3"
                        onClick={() => refetch()}
                    >
                        Refresh
                    </button>
                    <ItemGroup attributeGroup={pendingAttributeGroup} />
                    <ItemGroup attributeGroup={completedAttributeGroup} />
                </div>
            )}
        </div>
    );
    return (
        <div className="Details">
            <PlainHeader title="All change requests" />
            <div className="Details__content">
                <div className="Details__baseData">
                    <Card title="Change Requests" content={content} />
                </div>
            </div>
        </div>
    );
}
